import { Controller } from "@hotwired/stimulus"

// Fills the login form with a demo account (development and staging only)
export default class extends Controller {
  static targets = ["personalId", "password"]

  fill({ params: { personalId, password } }) {
    // Stimulus casts params that parse as JSON numbers
    this.personalIdTarget.value = String(personalId)
    this.passwordTarget.value = password
    this.passwordTarget.form.querySelector("[type=submit]")?.focus()
  }
}
